/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Closed set resolved server-side. A definition cannot introduce a new action.
 */
export type SafetyAction = (typeof SafetyAction)[keyof typeof SafetyAction];

export const SafetyAction = {
  self_harm_follow_up: "self_harm_follow_up",
} as const;
